import PropTypes from 'prop-types'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import Input from '../../../../../components/forms/Input'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { isUndefined } from 'lodash'
import JobAction from 'import/actions/JobAction'
import { useDispatch } from 'react-redux'
import { DefaultDialogTitle } from '../../../../../components/styled/Dialog'
import { createLightColor } from '../../../../../utils/ColorUtil'

const ImportFileDialog = ({
    open,
    setOpen,
    url = '',
    onChange = () => {},
}) => {
    const dispatch = useDispatch()

    const [name, setName] = useState()
    const [directory, setDirectory] = useState(url)
    const [content, setContent] = useState('')

    const onImportFile = (e) => {
        const reader = new FileReader()
        const file = e.target.files[0]
        setName(file.name)
        reader.onload = upload => setContent(upload.target.result)
        reader.readAsDataURL(file)
    }

    const onUpload = () =>{
        const parameters = {
            stationType: 0,
            stationId: 0,
            path: directory || '',
            name,
            content,
        }
        dispatch(JobAction.uploadFile(parameters)).then(res => res && onChange(res.name))
        setOpen(false)
    }
    return (
        <Dialog open={open} maxWidth='lg'>
            <DefaultDialogTitle title={i18n.importParam} onClose={() => setOpen(false)}/>
            <DialogContent>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid size={3}>
                                <label
                                    style={{ color: createLightColor('grey'), fontWeight: 'bold', fontSize: '1rem' }}
                                >
                                    {i18n.importFile}
                                </label>
                            </Grid>
                            <Grid size={3}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    component='label'
                                    fullWidth
                                >
                                    <span>{i18n.chooseFile}</span>
                                    <input
                                        type='file'
                                        hidden
                                        onChange={onImportFile}
                                    />
                                </Button>
                            </Grid>
                            <Grid size={6}>
                                <Input
                                    value={name ?? i18n.pleaseSelectFile}
                                    style={{ marginTop: '-0.5rem' }}
                                    disabled
                                />
                            </Grid>
                            <Grid size={3}>
                                <label
                                    style={{ color: createLightColor('grey'), fontWeight: 'bold', fontSize: '1rem' }}
                                >
                                    {i18n.directory}
                                </label>
                            </Grid>
                            <Grid size={9}>
                                <Input
                                    value={directory}
                                    onChange={setDirectory}
                                    style={{ marginTop: '-0.5rem' }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => setOpen(false)}
                >
                    {i18n.cancel}
                </Button>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={onUpload}
                    disabled={isUndefined(name) || isUndefined(content)}
                >
                    {i18n.importLabelFtp}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ImportFileDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    url: PropTypes.string,
    onChange: PropTypes.func,
    uploadFile: PropTypes.func,
}
export default ImportFileDialog
